import { getStraightPath } from '@xyflow/react';
import PropTypes from 'prop-types';

export default function CustomLine({
  fromX,
  fromY,
  toX,
  toY,
}) {
  const [edgePath] = getStraightPath({
    sourceX: fromX,
    sourceY: fromY,
    targetX: toX,
    targetY: toY
  });

  return (
    <path
      fill="none"
      stroke="#b1b1b7"
      strokeWidth={2}
      className="react-flow__custom-connection-line"
      d={edgePath}
    />
  );
}

CustomLine.propTypes = {
  fromX: PropTypes.number.isRequired,
  fromY: PropTypes.number.isRequired,
  toX: PropTypes.number.isRequired,
  toY: PropTypes.number.isRequired
}